import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { ContactForm } from '../core/ContactForm';
export interface ContactUsProps extends BaseComponentProps {
    lang: string;
    history?: History;
}

export interface ContactUsState extends BaseComponentState { }

export class ContactUs extends BaseComponent<ContactUsProps, ContactUsState> {

    constructor(props: ContactUsProps) {
        super(props);
    }

    render() {
        if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
        return (
            <div>
                <h4 style={{ borderBottom: '1px solid #eee' }}>Get in touch</h4>
                <p>We’d love to hear from you and help you to start planning your Bali holiday! All hotels can be booked directly through the website, or if you have any questions, please fill in the form below or email info@balihotelsandmore.com </p>
                <h4 style={{ borderBottom: '1px solid #eee' }}>Contact Us</h4>
                <ul className="list-unstyled"> 
                    <li>
                        <i className="icon icon-phone" /><strong>Phone:</strong> 1300 582556 
										</li>
                    <li>
                        <i className="icon icon-envelope" /><strong>Email:</strong>
                        <a href="mailto:info@balihotelsandmore.com"> info@balihotelsandmore.com </a>
                    </li>
                </ul>
                  
                <ContactForm from={'/contact-us'} lang={this.props.lang}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/static-content/ContactUs.tsx